import { QueryCondition } from '@edulead/models';
import type { Edulead } from 'edulead';
import { eduleadV4 } from '../services/edulead-v4-client';
import { EXPORT_ENTITIES } from '../pages/export-steps/exportShapes';
import { convertQtoQuery } from './queryConverter';

interface NewExportConfig {
  type: 'selected' | 'all';
  ids?: string[];
  entity: 'CONTACT' | 'INSTITUTION';
  searchParams: any;     // baseSearchParams object
  query?: QueryCondition[];  // pre-built query; when given it is used instead of searchParams.q
  estimatedCount: number;
  savedSearchId?: string;  // ID of the saved search this export originated from
}

export const isNewExportEnabled = (_teamId: string | undefined): boolean => {
  return true;
};

export const handleNewExport = async (config: NewExportConfig): Promise<string> => {
  const { type, ids, entity, searchParams, query: prebuiltQuery, estimatedCount, savedSearchId } = config;

  // Either ids OR conditions, not both
  let apiRequest: Edulead.EduleadV4Export;

  if (type === 'selected' && ids?.length) {
    // Export by IDs
    apiRequest = {
      record_ids: ids,
      entity: EXPORT_ENTITIES[entity],
      estimated_count: estimatedCount,
      search_id: savedSearchId,
    };
  } else {
    // Export by query. The query must be exactly what the search ran: the search never
    // applies the page's institution type, so the export must not add one either, or
    // an "export all" from the Institutions directory silently drops every school and
    // agency the user saw in the results.
    const query = prebuiltQuery ?? convertQtoQuery(searchParams?.q || '');

    // The conditions are the query as JSON, exactly as the search sent it
    apiRequest = {
      conditions: JSON.stringify(query),
      entity: EXPORT_ENTITIES[entity],
      estimated_count: estimatedCount,
      search_id: savedSearchId,
    };
  }

  console.log('handleNewExport - creating export:', apiRequest);

  try {
    const { export: created } = await eduleadV4.exports.create({ request_id: crypto.randomUUID(), export: apiRequest });
    console.log('Export created:', created);
    if (!created?.id) {
      throw new Error('Export created but no ID returned');
    }
    return created.id;
  } catch (error) {
    console.error('Failed to create export:', error);
    throw error;
  }
};
